import type {ReactElement} from 'react';
import React, {useState} from 'react';
import type {GRID_ITEM_TYPE, GridItemProps} from '../grid-item';
import type {GridMediaItemStorage} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import {MultipagePreview} from '@Components/multipage-preview';

export interface GridMultipageItemStorage extends GridMediaItemStorage {
  type: GRID_ITEM_TYPE.MULTIPAGE;
  previewURLs: string[];
  fallbackPreviewURLs: string[];
  videoPreviewURLs: string[];
  pagesIsVideo: boolean[];
  pageCount: number;
  pageHashedIDs: string[];
  templateName: string;
  data: Record<string, unknown>;
}

interface GridMultipageItemProps extends GridItemProps {
  previewURLs: string[];
  fallbackPreviewURLs: string[];
  videoPreviewURLs: string[];
  pagesIsVideo: boolean[];
  pageCount: number;
  isLoading?: boolean;
}

export function GridMultipageItem({
  previewURLs,
  fallbackPreviewURLs,
  videoPreviewURLs,
  pagesIsVideo,
  pageCount,
  ...props
}: GridMultipageItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <MultipagePreview
          previewURLs={previewURLs}
          fallbackPreviewURLs={fallbackPreviewURLs}
          videoPreviewURLs={videoPreviewURLs}
          pagesIsVideo={pagesIsVideo}
          pageCount={pageCount}
          onImageLoad={(): void => {
            setIsImageLoaded(true);
          }}
        />
      }
      paddedThumb={false}
    />
  );
}
